// utils/secureStorage.js
import CryptoJS from "crypto-js";

// 🔐 Make this secret key secure and random in production
const SECRET_KEY = "your-secret-key";

// Encrypt any JS object or string
export const encryptData = (data) => {
  try {
    const strData = typeof data === "string" ? data : JSON.stringify(data);
    return CryptoJS.AES.encrypt(strData, SECRET_KEY).toString();
  } catch (err) {
    console.error("Encryption error:", err);
    return null;
  }
};

// Decrypt back to original object/string
export const decryptData = (cipherText) => {
  try {
    const bytes = CryptoJS.AES.decrypt(cipherText, SECRET_KEY);
    const decrypted = bytes.toString(CryptoJS.enc.Utf8);
    try {
      // Agar JSON parse ho jaaye to object return karo
      return JSON.parse(decrypted);
    } catch {
      // Agar string hi hai to wahi return karo
      return decrypted;
    }
  } catch (err) {
    console.error("Decryption error:", err);
    return null;
  }
};

// Save any key-value pair securely
export const setSecureItem = (key, value) => {
  try {
    const encrypted = encryptData(value);
    if (encrypted) localStorage.setItem(key, encrypted);
  } catch (err) {
    console.error("setSecureItem error:", err);
  }
};

// Retrieve any key-value pair
export const getSecureItem = (key) => {
  try {
    const cipherText = localStorage.getItem(key);
    if (!cipherText) return null;
    return decryptData(cipherText);
  } catch (err) {
    console.error("getSecureItem error:", err);
    return null;
  }
};

// Remove any stored key
export const removeSecureItem = (key) => {
  localStorage.removeItem(key);
};

// ✅ Optional helper for user data specifically
export const saveUserData = (data) => setSecureItem("authData", data);
export const getUserData = () => getSecureItem("authData");
export const clearUserData = () => removeSecureItem("authData");
